<header *ngIf="(authenticationService.organisation$ | async)">
  <img src="{{ (authenticationService.organisation$ | async)?.logo }}" alt="{{ (authenticationService.organisation$ | async)?.display_name }}">
</header>
<fury-page-layout>
  <fury-page-layout-content @fadeInUp>
    <fury-container>
      <fury-page-layout-content-width wide="middle">
        <ng-container *ngIf="!report && !isLoading">
          <fury-alert-box class="warn">
            Er is geen melding gevonden.
          </fury-alert-box>
        </ng-container>
        <div *ngIf="report">
          <h1>Volgen van uw melding</h1>
          <fury-report-progress [report]="report"></fury-report-progress>
          <div class="white-background">
            <h3>Uw melding</h3>
            <div class="row">
              <div class="title">Rapportnummer:</div>
              <div class="content">{{ report.number }}</div>
            </div>
            <div class="row">
              <div class="title">Status</div>
              <div class="content">
                <div class="status" [style.background]="report.status.color">{{ report.status.display_name }}</div>
              </div>
            </div>
            <div class="row" *ngIf="!report.complaint.location_unknown">
              <div class="title">Locatie:</div>
              <div class="content">
                {{ report.complaint.location }}
                <div class="link" (click)="viewLocation({lat: report.complaint.lat, lng: report.complaint.lng})">
                  <mat-icon>pin_drop</mat-icon>
                  <span class="text">bekijk op de kaart</span>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="report.complaint.location_unknown">
              <div class="title">Locatie toelichting:</div>
              <div class="content">{{ report.complaint.location_description }}</div>
            </div>
            <div class="row">
              <div class="title">Hoofdcategorie:</div>
              <div class="content">{{ report.head_category.name }}</div>
            </div>
            <div class="row">
              <div class="title">Subcategorie:</div>
              <div class="content">{{ report.sub_category?.name }}</div>
            </div>
            <div class="row">
              <div class="title">Toelichting:</div>
              <div class="content with-newline">{{ report.description }}</div>
            </div>
            <ng-container *ngIf="report.attachments.total">
              <h3>Foto('s) van uw melding</h3>
              <div class="row photos">
                <fury-attachments [attachments]="report.attachments.all" [reportUniqueId]="reportUniqueId"></fury-attachments>
              </div>
            </ng-container>

            <h3>Uw contact gegevens</h3>
            <ng-container *ngIf="report.reporter.anonymous">
              <div class="row">
                <div class="title">Anoniem</div>
              </div>
            </ng-container>
            <ng-container *ngIf="!report.reporter.anonymous">
              <div class="row">
                <div class="title">Aanhef:</div>
                <div class="content">{{ report.reporter?.prefix }}</div>
              </div>
              <div class="row">
                <div class="title">Voorletters:</div>
                <div class="content">{{ report.reporter?.initials }}</div>
              </div>
              <div class="row">
                <div class="title">Achternaam:</div>
                <div class="content">{{ report.reporter?.lastname }}</div>
              </div>
              <div class="row">
                <div class="title">Uw adres:</div>
                <div class="content">{{ report.reporter?.location }}</div>
              </div>
              <div class="row">
                <div class="title">E-mail:</div>
                <div class="content">{{ report.reporter?.email }}</div>
              </div>
              <div class="row">
                <div class="title">Telefoonnummer:</div>
                <div class="content">{{ report.reporter?.phone }}</div>
              </div>
            </ng-container>
            <ng-container *ngIf="report.handling.future_note">
              <h3>Tussenbericht notitie</h3>
              <div [innerHTML]="report.handling.future_note"></div>
            </ng-container>
            <ng-container *ngIf="report.handling.resolved_note">
              <h3>Melding voltooid notitie</h3>
              <div [innerHTML]="report.handling.resolved_note"></div>
            </ng-container>
            <ng-container *ngIf="report.handling.rejected_note">
              <h3>Melding afgewezen notitie</h3>
              <div [innerHTML]="report.handling.rejected_note"></div>
            </ng-container>

            <ng-container *ngIf="report.handling.attachments.total">
              <h3>Bijlage afhandeling</h3>
              <div class="row photos">
                <fury-attachments [attachments]="report.handling.attachments.all" [type]="'handling'" [reportUniqueId]="reportUniqueId"></fury-attachments>
              </div>
            </ng-container>

            <ng-container *ngIf="report.editable">
              <ng-container *ngIf="report.status.name === 'resolved' || report.status.name === 'rejected'">
                <h3>Heropen van uw melding</h3>
                <p *ngIf="report.editable === 'expired'">Het is inmiddels meer dan een maand geleden dat deze melding is afgehandeld. Wilt u de melding alsnog
                  heropenen? Maak dan een nieuwe melding aan of neem telefonisch contact met ons op.</p>
                <p *ngIf="report.editable !== 'expired'">Is de melding nog niet volledig afgehandeld? Heropen uw melding en voeg aanvullende informatie toe dan
                  behandelen wij uw melding opnieuw.</p>
              </ng-container>
              <ng-container *ngIf="report.status.name === 'not-assigned'">
                <h3>Aanvullende gegevens van uw melding</h3>
                <p>Heeft u extra informatie die ons kan helpen om de melding sneller op te lossen?</p>
              </ng-container>
              <button color="primary" mat-button type="button" (click)="toggleForm()" *ngIf="!showForm && report.editable === true">
                Meer gegevens toevoegen
                <mat-icon>add</mat-icon>
              </button>

              <div class="form-container" *ngIf="showForm && report.editable === true">
                <form [formGroup]="form" *ngIf="!formSubmitting && !formSubmitted">
                  <div [class.has-error]="form.controls.description.errors && form.controls.description.touched" class="container">
                    <mat-icon aria-hidden="true">warning</mat-icon>
                    <mat-label>Toelichting van uw melding <sup>*</sup></mat-label>
                    <textarea formControlName="description" placeholder="Beschrijf zo duidelijk mogelijk wat er aan de hand is"
                              maxlength="1000" rows="4" class="sentry-mask"></textarea>
                    <mat-hint class="word-counter">{{ form.controls.description.value.length }} / 5000</mat-hint>
                  </div>

                  <div [class.has-error]="form.controls.attachments.errors && form.controls.attachments.touched" class="container">
                    <mat-icon aria-hidden="true">warning</mat-icon>
                    <mat-label>Fotos' van melding</mat-label>
                    <p>Toevoegen van een foto is niet verplicht maar kan handig zijn.</p>
                    <div (click)="uploadAttachments.open()" class="container-uploader">
                      Sleep uw bestanden hierheen of selecteer de bestanden (klik hier)
                      <ngx-mat-file-input #uploadAttachments (change)="detectUploadAttachments($event)" [multiple]="true"
                                          formControlName="attachmentsContainer"></ngx-mat-file-input>
                    </div>
                    <mat-hint class="mat-error" *ngIf="attachmentIgnored">
                      Eén van de door u aangeleverde bestanden wordt door ons niet geaccepteerd en zal niet worden verstuurd:
                      {{ attachmentIgnored }}
                    </mat-hint>
                    <mat-hint class="mat-error" *ngIf="attachmentCountExceeded">
                      Er kunnen maximaal {{ acceptedMaxAttachments }} bijlages worden toegevoegd.
                    </mat-hint>
                    <mat-hint class="mat-error" *ngIf="attachmentTotalSizeExceeded">
                      De maximale grootte voor bijlage(s) is {{ acceptedMaxSizeAttachments / 1024 / 1024 }}MB.
                    </mat-hint>
                    <mat-hint>
                      Maximaal {{ acceptedMaxAttachments }} bestanden toevoegen in bestandsformat .jpg, .png, .pdf, .mp4, .flv, .docx, en .xlsx niet groter
                      als {{ acceptedMaxSizeAttachments / 1024 / 1024 }}MB in
                      totaal.
                    </mat-hint>
                    <div class="attachments" #attachmentsPlaceholder></div>
                  </div>

                  <div class="actions" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="16px" fxLayoutGap.gt-sm="32px">
                    <button color="secondary" fxFlex="100" fxFlex.gt-sm="50" mat-button type="button" (click)="toggleForm()">
                      Annuleer
                      <mat-icon>cancel</mat-icon>
                    </button>
                    <button color="primary" fxFlex="100" fxFlex.gt-sm="50" mat-button [disabled]="!form.valid" (click)="submit()">
                      Aanpassen
                      <mat-icon>play_circle_outline</mat-icon>
                    </button>
                  </div>
                </form>
                <div *ngIf="formSubmitting" class="form-loading-overlay">
                  Uw melding wordt op dit moment verwerkt, een moment geduld aub ...
                  <div class="progress">
                    <div class="progress-bar" [style.width]="uploadProgress + '%'"></div>
                  </div>
                </div>
                <div *ngIf="formSubmitError" class="form-loading-error">
                  <p>Er is een fout opgetreden bij het maken van een melding. Probeer het later opnieuw.</p>
                </div>
                <div *ngIf="formSubmitted" class="form-loading-success">
                  <p>Wij hebben uw updates ontvangen en verwerken deze zo snel mogelijk.</p>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="(authenticationService.organisation$ | async)">
              <h3>Contact opnemen met {{ (authenticationService.organisation$ | async).display_name }}</h3>
              <p>
                Heeft u nog vragen naar aanleiding van uw melding? Neem dan contact op via <a
                href="mailto:{{ (authenticationService.organisation$ | async).email }}">{{ (authenticationService.organisation$ | async).email }}</a>
                of
                telefoonnummer <a
                href="tel:{{ (authenticationService.organisation$ | async).phone_number }}">{{ (authenticationService.organisation$ | async).phone_number }}</a>.
                Bij contact is het altijd handig om uw
                meldnummer {{ report.number }} te noemen.
              </p>
            </ng-container>
          </div>
        </div>
        <div *ngIf="isLoading" class="loader" fxFlex fxLayoutAlign="center center">
          <fury-loading-overlay [isLoading]="true"></fury-loading-overlay>
        </div>
      </fury-page-layout-content-width>
    </fury-container>
  </fury-page-layout-content>
</fury-page-layout>
